import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

import { mediaMax } from '@/styles/mixins'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  //width: 100%;
  will-change: transform;

  -ms-animation: marquee ${({ duration }) => duration} linear infinite;
  -o-animation: marquee ${({ duration }) => duration} linear infinite;
  -webkit-animation: marquee ${({ duration }) => duration} linear infinite;
  -moz-animation: marquee ${({ duration }) => duration} linear infinite;
  animation: marquee ${({ duration }) => duration} linear infinite;
  //
  @-webkit-keyframes marquee {
    from {
      -moz-transform: translateX(0);
      -o-transform: translateX(0);
      -ms-transform: translateX(0);
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    to {
      -moz-transform: translateX(-100%);
      -o-transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }
  @-moz-keyframes marquee {
    from {
      -moz-transform: translateX(0);
      -o-transform: translateX(0);
      -ms-transform: translateX(0);
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    to {
      -moz-transform: translateX(-100%);
      -o-transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }
  @-ms-keyframes marquee {
    from {
      -moz-transform: translateX(0);
      -o-transform: translateX(0);
      -ms-transform: translateX(0);
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    to {
      -moz-transform: translateX(-100%);
      -o-transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }
  @-o-keyframes marquee {
    from {
      -moz-transform: translateX(0);
      -o-transform: translateX(0);
      -ms-transform: translateX(0);
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    to {
      -moz-transform: translateX(-100%);
      -o-transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }
  @keyframes marquee {
    from {
      -moz-transform: translateX(0);
      -o-transform: translateX(0);
      -ms-transform: translateX(0);
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    to {
      -moz-transform: translateX(-100%);
      -o-transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }

  ${mediaMax.md} {
    padding: 3rem 0;
  }
`

export const Content = styled.div`
  color: ${({ theme }) => theme.colors.green};
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: bold;
  font-size: 13rem;
  white-space: nowrap;

  ${mediaMax.xs} {
    font-size: 5.5rem;
  }
`
export const ContentClone = styled(Content)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(calc(${({ index }) => `${index + 1} * 100%`}));
  left: 0;
`

export const Text = styled.div`
  padding: 0 6rem;
`
